export default __webpack_public_path__ + "static/media/Paints-v2.ec9de100.jpg";